import { log } from "../../api/dev"
import { base64ToUint8Array } from "../../api/helpers"

const MAX_CHUNK = 1024*8

export class ResourceReader{


    constructor(serverApi, type, resourceID, networkID, name, mimeType, onload){

        this.api = serverApi

        this.type = type
        this.resourceID = resourceID
        this.networkID = networkID

        this.buffer = null //new Uint8Array()

        this.size = 0
        this.readed = 0

        this.name = name
        this.mimeType = mimeType
        this.onload = onload

        this.api.registerResourceReader(this)

    }

    run(){

        const message = {
            MessageID: 'RESOURCE_REQUEST',
            Type: this.type,
            ResourceID: this.resourceID,
            NetworkID: this.networkID
        }
        log('RESOURCE_REQUEST query')
        log(message)
        this.api.ws.send(JSON.stringify([message]));

    }


    handleMessage(message){

        console.log('ResourceReader handleMessage')
        console.log(message)

        switch(message.MessageID){
            case 'RESOURCE_RESPONSE':{
                this.size = message.Size
                //alert('size='+message.Size)

                this.buffer = new Uint8Array(this.size)

                if(message.State===0){
                    //ok
                    if(!this.eof()){
                        this.read()
                    }

                }else if(message.State===1){
                    //fail
                    throw new Error('RESOURCE_RESPONSE bad query')
                }

                break
            }

            case 'RESOURCE_FETCH':

                let data = base64ToUint8Array(message.Data)
                //console.log('data')
                //console.log(data)

                this.buffer.set(data, this.readed)

                this.readed += data.length

                if(this.eof()){

                    this.close()

                    //alert('EOF')
                    //console.log('EOF')
                    //console.log(this.name)
                    //console.log(this.mimeType)
                    //console.log(this.buffer)


                    const b = new Blob([this.buffer], {type: this.mimeType, name: this.name});//'application/octet-stream'
                    //console.log(b)


                    this.api.unregisterResourceReader(this)

                    if(this.onload) this.onload(URL.createObjectURL(b))

                }else{
                    this.read()
                }

                break
        }


    }

    eof(){
        return this.readed >= this.size
    }

    read(){

        let size = this.size - this.readed > MAX_CHUNK ? MAX_CHUNK : this.size - this.readed

        const message = {
            MessageID: 'RESOURCE_READ',
            Type: this.type,
            ResourceID: this.resourceID,
            Size: size,
            NetworkID: this.networkID
        }
        log('RESOURCE_READ query')
        log(message)
        this.api.ws.send(JSON.stringify([message]));

    }

    close(){
        const message = {
            MessageID: 'RESOURCE_CLOSE',
            Type: this.type,
            ResourceID: this.resourceID,
            NetworkID: this.networkID
        }
        log('RESOURCE_CLOSE query')
        log(message)
        this.api.ws.send(JSON.stringify([message]));
    }


}